import CloseIcon from '@mui/icons-material/Close'
import ReactDOM from 'react-dom'

import ExpoLogo from 'pared/images/Expo/expo-symbol-white-1x.svg'

import {
  ButtonGroup,
  ChatButton,
  ChatButtonContainer,
  ChatButtonTitle,
  ChatContainer,
  ChatHeader,
  ChatIcon,
  ChatIframe,
  ChatWindow,
  HeaderTitle,
  StyledExpandIcon,
  StyledIconButton,
  StyledShrinkIcon,
} from './styles'
import { IPropsType } from './types'
import { useChatBox } from './useChatBox'

export type { IPropsType }

const ChatComponent = ({
  agentCode,
  sendStoreId,
  width,
  height,
  hideFromNonExpoUsers,
}: IPropsType) => {
  const {
    isOpen,
    setIsOpen,
    isExpanded,
    setIsExpanded,
    iframeUrl,
    iframeRef,
    userInfo,
  } = useChatBox({ agentCode, sendStoreId })

  if (hideFromNonExpoUsers && !userInfo?.email?.endsWith('@getexpo.com')) {
    return null
  }

  const chatContent = (
    <ChatContainer isExpanded={isExpanded}>
      <ChatButtonContainer isOpen={isOpen}>
        <div></div>
        <ChatButton onClick={() => setIsOpen(!isOpen)}>
          <ChatIcon src={ExpoLogo} alt="Expo Logo Icon" />
          <ChatButtonTitle>Ask Expo</ChatButtonTitle>
        </ChatButton>
      </ChatButtonContainer>

      <ChatWindow
        isOpen={isOpen}
        width={width}
        height={height}
        isExpanded={isExpanded}
      >
        <ChatHeader onClick={() => setIsOpen(false)}>
          <HeaderTitle>
            <ChatIcon src={ExpoLogo} alt="Expo Logo Icon" />
            Ask Expo
          </HeaderTitle>
          <ButtonGroup>
            {isExpanded ? (
              <StyledShrinkIcon
                onClick={(e) => {
                  e.stopPropagation()
                  setIsExpanded(false)
                }}
              />
            ) : (
              <StyledExpandIcon
                onClick={(e) => {
                  e.stopPropagation()
                  setIsExpanded(true)
                }}
              />
            )}
            <StyledIconButton
              onClick={(e) => {
                e.stopPropagation()
                setIsOpen(false)
                setIsExpanded(false)
              }}
            >
              <CloseIcon />
            </StyledIconButton>
          </ButtonGroup>
        </ChatHeader>
        <ChatIframe
          ref={iframeRef}
          src={iframeUrl || ''}
          title="Expo Sous-Chef"
          allow="microphone"
        />
      </ChatWindow>
    </ChatContainer>
  )

  return ReactDOM.createPortal(chatContent, document.body)
}

export default ChatComponent
